import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { REDIRECT_PATH } from 'utility/constants/auth';

/** Standardize login hook */
export function useLogin() {
	const { signinRedirect } = useAuth();

	const login = useCallback(
		/** @param {Parameters<signinRedirect>[0]} [opts] */
		async (opts) => {
			const { pathname } = globalThis.location;
			sessionStorage.setItem(REDIRECT_PATH, pathname);
			await signinRedirect(opts);
		},
		[signinRedirect],
	);

	return login;
}

export default useLogin;
